export class MessageDetailsResponse{
    Status:string;
    StatusCode:number;
    StatusText:string;
    
}

export class MessageResponse
{
    Message:string;
    MessageId:string;
}
export class ResultContent
{
    MessageId:string;
    SenderAddress:string;
    Subject:string;
    MessageDate:string;
    IsExpiredReceipt:boolean;
    ReceiptStatus:number;
    ReceiptGenerated:boolean;
    MessageExists:boolean;
    Language:string;
    ResponseStatus:number;
    ResponseMessage:string;
    IsDownloaded:boolean;
}
export class DownloadLargeReceipt{
    FileName!: string;
    ReceiptFor!: string;
    ReceiptDate!: string;
}

export interface IDownloadLargeReceipt{

    FileName: string;
    ReceiptFor: string;
    ReceiptDate: Date;
}

export interface IDownloadLargeReceiptHF {
    Status: string;
    StatusCode: string;
    StatusText: string;
    Message: any;
    ResultContent: IDownloadLargeReceipt;
  }

export interface IMessageDetails
{
    Status:string;
    StatusCode:number;
    StatusText:string;
    Message:IMessageResponse;
    ResultContent:IResultContent;
}

export interface IMessageResponse
{
    Message:string;
    MessageId:string;

}

export interface IResultContent
{
    MessageId:string;
    SenderAddress:string;
    Subject:string;
    MessageDate:string;
    IsExpiredReceipt:boolean;
    ReceiptStatus:number;
    ReceiptGenerated:boolean;
    MessageExists:boolean;
    Language:string;
    ResponseStatus:number;
    ResponseMessage:string;
    IsDownloaded:boolean;
    ReceiptVerifiedEmailDownloadMaxHours:number;
}

export interface IReceiptFileUploadDetails
{
    Status:string;
    StatusCode:number;
    StatusText:string;
    Message:IMessageResponse;
    ResultContent:IResultContent_ReceiptFileUpload;
}

export interface IResultContent_ReceiptFileUpload
{
    FileName:string;
    FileId:string;
    ResponseMessage:string;
}

export class ReceiptFileUploadDetails
{
    Status:string;
    StatusCode:number;
    StatusText:string;
    Message:IMessageResponse;
    ResultContent:IResultContent_ReceiptFileUpload;
}

export class ResultContent_ReceiptFileUpload
{
    FileName:string;
    FileId:string;
    ResponseMessage:string;
}

export class SenderDetails
{
        Status:string;
        StatusCode:number;
        StatusText:string;
        Message:IMessageResponse;
        ResultContent:IResultContent_SenderDetails;
}

export interface ISenderDetails
{
        Status:string;
        StatusCode:number;
        StatusText:string;
        Message:IMessageResponse;
        ResultContent:IResultContent_SenderDetails;
}
export class ResultContent_SenderDetails
{
        MessageId:string;
        SenderAddress:string;

         SenderName:string;

         Language:string

        IsEligibleforAuthentication:boolean;

        ResponseMessage:string;
}

export interface IResultContent_SenderDetails
{
        MessageId:string;
        SenderAddress:string;

         SenderName:string;

         Language:string

        IsEligibleforAuthentication:boolean;

        ResponseMessage:string;
}


    export class ResultContent_DownloadAuthenticateReceipt
    {
        MessageId:string;
        IsReceiptExpired:boolean;
        IsReceiptDownloaded:boolean;
        ResponseMessage:string;
    }

    export interface IResultContent_DownloadAuthenticateReceipt
    {
        MessageId:string;
        IsReceiptExpired:boolean;
        IsReceiptDownloaded:boolean;
        ResponseMessage:string;
    }

    export class ReceiptDownloadDetails
    {
        Status:string;
        StatusCode:number;
        StatusText:string;
        Message:IMessageResponse;
        ResultContent:IResultContent_DownloadAuthenticateReceipt
        
    }

    export interface IReceiptDownloadDetails
    {
        
        Status:string;
        StatusCode:number;
        StatusText:string;
        ResponseMessage:string;
        Message:IMessageResponse;
        ResultContent:IResultContent_DownloadAuthenticateReceipt
    }





